import { Link } from 'react-router-dom'
import { createPortal } from 'react-dom'
import CloseButton from 'react-bootstrap/CloseButton'
import { PopupInfo } from './ActiontMap'

interface Props {
  layerPoint: {x: number, y: number}
  popupPane: HTMLElement | null | undefined
  setPopupPane: (popupPane: HTMLElement | null | undefined) => void
  childType: string
  data: PopupInfo | null
}

const PopUp = ({ layerPoint, data, childType, popupPane, setPopupPane }: Props) => {
  if ((data == null) || !layerPoint || (popupPane == null)) return null

  const popupContent = (
    <div className='leaflet-popup leaflet-zoom-animated' style={{ transform: `translate3d(${layerPoint.x}px, ${layerPoint.y}px, 0px)`, bottom: -7, left: -83, zIndex: 100, width: 'max-content' }}>
      <div className='leaflet-popup-content-wrapper'>
        <div className='leaflet-popup-content'>
          <div className='d-flex justify-content-end align-content-center'><CloseButton onClick={() => setPopupPane(null)} /></div>
          <div className='d-flex justify-content-between align-content-center'>
            <div><p className='font-weight-bold'>{data.text}</p></div>
            {childType !== 'votingdistrict' && <div className='pl-2'><p><Link to={`/${childType}/${data.code}/action`}>Zoom in</Link></p></div>}
          </div>
          <table className='break-before bordered stats table table-striped'>
            <tbody>
              {
                    // @ts-expect-error
                    data.values.map(v => (
                      <tr key={v.metric}>
                        <td className='p-2'><b>{v.metric}</b></td>
                        <td className='p-2'>{v.metricNumber}</td>
                      </tr>
                    ))
}
            </tbody>
          </table>
        </div>
      </div>
      <div className='leaflet-popup-tip-container'><div className='leaflet-popup-tip' /></div>
    </div>
  )

  return createPortal(popupContent, popupPane)
}

export default PopUp
